// extracted by mini-css-extract-plugin
module.exports = {"InfoModal":"InfoModal_InfoModal__2f_0_"};